import React from 'react';
import styled from 'styled-components';

import Tag from 'antd/es/tag';

import { Text } from 'components/Text';

const StyledTag = styled(Tag)`
  text-transform: capitalize;
  color: #1560AD;
  background: #EFF2F5;
  border: 1px solid #DAE0E6;

  & .name {
    color: #828C94;
    font-size: 12px;
    line-height: 20px;
  }

  & .value {
    color: #828C94;
    font-weight: 600;
    font-size: 13px;
    line-height: 22px;
  }
`;

const FilterTag = ({ name, value, ...rest }) => {
  return (
    <StyledTag {...rest}>
      <Text className="name">{name}:</Text>&nbsp;
      <Text className="value">{value}</Text>
    </StyledTag>
  );
};

export default FilterTag;
